module.exports = __webpack_public_path__ + "img/thumbnail.a36832a1.png";